<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Epigraph" epub:type="backmatter">
<p class="epi"><span aria-label=" Page x. " epub:type="pagebreak" id="pg_x" role="doc-pagebreak">“Darkness doesn’t kill the light—it defines it.”</span></p>
<p class="ded1"><b>—Richard Wagamese</b></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?01243cab